module.exports = __webpack_public_path__ + "img/ardoise.71a1ace5.jpeg";